module.exports = __webpack_public_path__ + "static/media/projects.84d67385.svg";